import React from 'react';
import { Typography, Paper } from '@material-ui/core';

const FailureCard: React.FC = () => (
  <Paper style={{ padding: 24 }}>
    <Typography variant="h4" gutterBottom>
      Authentication failed
    </Typography>
    <Typography variant="body1" gutterBottom>
      The authentication token couldn't be validated.
      The token may be invalid or the issuer could not be reachable.
      Please check and try again.
    </Typography>
  </Paper>
);

export default FailureCard;
